<script setup lang="ts">
// This component shows a blank white screen for users with incorrect scopes
</script>

<template>
  <div class="min-h-screen bg-white">
    <!-- Intentionally blank white screen for unauthorized users -->
  </div>
</template> 